module.exports = __webpack_public_path__ + "static/media/vaccine_p3_1.9ece82aa.png";